import React from 'react'

const ProgramCurationPreview = () => {
    return (
        <>
            <div>
                <h1>Program Curation Preview</h1>
                <p>Program Curation Preview page for a specific program.</p>
                <p>Under Construction.</p>
            </div>
        </>
    );
}

export default ProgramCurationPreview;